import { ExternalLink } from 'lucide-react';
import React from 'react';

interface ExternalLinkBadgeProps {
  href: string;
  label: string;
  className?: string;
}

export const ExternalLinkBadge: React.FC<ExternalLinkBadgeProps> = ({
  href,
  label,
  className = '',
}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center gap-1 text-xs sm:text-[11px] lg:text-xs hover:bg-zinc-100 px-1.5 py-0.5 rounded transition-colors bg-zinc-50 ${className}`}
    aria-label={`View ${label}`}
  >
    <ExternalLink className="h-3 w-3" />
    <span className="font-medium">{label}</span>
  </a>
);
